<template>
  <div id="app" v-cloak>
    <el-container v-if="isShow" class="container">
      <el-aside width="200px" class="asides">
        <div class="left">
          <img src="../../assets/img/logo.png" alt style="width:100px;height:auto" />
        </div>
        <div class="list">
          <el-menu
            :default-active="pathActive?this.pathActive:this.$route.path"
            class="el-menu-vertical-demo"
            :unique-opened="true"
            background-color="#262835"
            text-color="#7C8EA2"
            active-text-color="#fff"
            @open="handleOpen"
            @close="handleClose"
          >
            <el-menu-item index="/home" class="aside" @click="enterHome">
              <span class="el-icon-s-home"></span>
              <span slot="title">首页</span>
            </el-menu-item>
            <!-- 新改的 -->
            <el-menu-item index="/shopifyOrder" @click="enterShopifyOrder">
              <span class="el-icon-s-order"></span>订单
            </el-menu-item>
            <el-menu-item index="/sku" @click="enterSKU">
              <span class="el-icon-data-line"></span>SKU
            </el-menu-item>
            <!-- <el-menu-item index="/client" class="aside" @click="enterClient">
              <span class="iconfont icon-kehu"></span>
              <span slot="title">客户</span>
            </el-menu-item>-->
            <el-menu-item index="/logistics" class="aside" @click="enterLogistics" v-if="false">
              <span class="el-icon-odometer"></span>
              <span slot="title">物流</span>
            </el-menu-item>
            <el-submenu index="8">
              <template slot="title">
                <span class="el-icon-set-up"></span>
                <span>营销</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/pitching" @click="enterPitching">投手日报</el-menu-item>
                <el-menu-item index="/advNumber" @click="enterAdvNumber">广告账号</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item index="/operationalData" @click="enterOperationalData">
              <span class="el-icon-s-data"></span>数据
            </el-menu-item>

            <el-menu-item index="/shopifyStores" @click="enterShopifyStores">
              <span class="el-icon-data-board"></span>店铺
            </el-menu-item>
            <el-menu-item
              index="/dispute"
              @click="$router.push({
                  path:'/dispute'
                })"
            >
              <span class="el-icon-phone-outline"></span>客诉
            </el-menu-item>
            <el-submenu index="11">
              <template slot="title">
                <span class="el-icon-setting"></span>
                <span>设置</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/logisticsAcc" @click="$router.push({
                  path:'/logisticsAcc'
                })">物流账号设置</el-menu-item>
                <!-- <el-menu-item index="/freightList" @click="enterFreightList">运费费率表</el-menu-item> -->
                <el-menu-item index="/paymentSet" @click="enterPaymentSet">收款设置</el-menu-item>
                <!-- <el-menu-item index="/logisticsSet" @click="enterLogisticsSet">物流设置</el-menu-item> -->
                <el-menu-item index="/addUser" @click="enterAddUser">员工管理</el-menu-item>
                <el-menu-item index="/roleManager" @click="enterRoleManager">角色管理</el-menu-item>
                <el-menu-item
                  index="/wuliu"
                  @click="$router.push({
                  path:'/wuliu'
                })"
                >物流设置</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item
              v-if="userInfo.userAccountName=='admin'"
              index="/see"
              @click="$router.push({
                  path:'/see'
                })"
            >
              <span class="el-icon-view"></span>查看
            </el-menu-item>
          </el-menu>
        </div>
      </el-aside>
      <el-container>
        <el-header class="headers">
          <div class="left">{{userInfo.companyName}}</div>
          <div class="right">
            <div class="headImg">
              <img
                src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1605093020783&di=de6c1a19c9d3af0748f7bb2f7ca53e1b&imgtype=0&src=http%3A%2F%2Fbpic.588ku.com%2Felement_origin_min_pic%2F01%2F48%2F83%2F33574441b251f42.jpg"
                alt
              />
            </div>
            <span class="name">{{userInfo.userAccountName}}</span>
            <span>|</span>
            <span class="isLogin" style="margin-right:10px" @click="showEditPassword">修改密码</span>
            <span>|</span>
            <span class="isLogin" @click="exitLogin">退出</span>
          </div>
        </el-header>
        <el-main class="mains">
          <keep-alive>
            <router-view class="contents routerView" v-if="$route.meta.keepAlive" />
          </keep-alive>
          <router-view class="contents routerView" v-if="!$route.meta.keepAlive" />
        </el-main>
        <el-footer class="footers">
          <copy-right></copy-right>
        </el-footer>
      </el-container>
    </el-container>
    <div v-else style="height:100%;">
      <router-view class="routerView" :key="this.$route.path" />
    </div>
  </div>
</template>

<script>
import copyRight from "../../components/copyRight";
import { GetUserHeaderInfo, EditUserPassword } from "@/utils/api";
export default {
  data() {
    return {
      isShow: true,
      pathActive: "",
      userInfo: {}
    };
  },
  watch: {
    $route(to, from) {
      if (to.path === "/shopify/redirect" || to.path === "/login") {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
      if (to.path === "/orderDetail") {
        this.pathActive = "/shopifyOrder";
      } else if (to.path === "/sku/addSku" || to.path === "/sku/editSku") {
        this.pathActive = "/sku";
      } else if (to.path === "/addGoods") {
        this.pathActive = "/goods";
      } else if (to.path === "/discount/add" || to.path === "/discount/edit") {
        this.pathActive = "/discount";
      } else if (to.path === "/FBaccount/add") {
        this.pathActive = "/FBaccount";
      } else if (to.path === "/advNumberDetail") {
        this.pathActive = "/advNumber";
      } else {
        this.pathActive = "";
      }
    }
  },
  methods: {
    showEditPassword() {
      this.$prompt("请输入密码", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "password",
        inputPattern: /\S/,
        inputErrorMessage: "密码不能为空"
      })
        .then(({ value }) => {
          EditUserPassword({
            Password: value
          }).then(res => {
            if (res) {
              this.$message({
                type: "success",
                message: "修改密码成功"
              });
              sessionStorage.removeItem("token");
              sessionStorage.removeItem("appToken");
              setTimeout(() => {
                this.$router.push({
                  path: "/login"
                });
              }, 1000);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },
    // 首页
    enterHome() {
      this.$router.push({
        path: "/"
      });
    },
    // 客户
    enterClient() {
      this.$router.push({
        path: "/client"
      });
    },
    // 商品管理
    enterGoods() {
      this.$router.push({
        path: "/goods"
      });
    },
    // 订单
    enterOrder() {
      this.$router.push({
        path: "/order"
      });
    },
    // shopify订单
    enterShopifyOrder() {
      this.$router.push({
        path: "/shopifyOrder"
      });
    },
    // 设置
    enterSetting() {
      this.$router.push({
        path: "/setting"
      });
    },
    // 商品系列列表
    enterGoodsSerieslist() {
      this.$router.push({
        path: "/goodsSerieslist"
      });
    },
    // 运费费率表
    enterFreightList() {
      this.$router.push({
        path: "/freightList"
      });
    },
    // 绑定店铺
    enterBindStore() {
      this.$router.push({
        path: "/bindStore"
      });
    },
    // 店铺列表
    enterStores() {
      this.$router.push({
        path: "/stores"
      });
    },
    //运营数据
    enterOperationalData() {
      this.$router.push({
        path: "/operationalData"
      });
    },
    //投手日报
    enterPitching() {
      this.$router.push({
        path: "/pitching"
      });
    },
    // shopify店铺列表
    enterShopifyStores() {
      this.$router.push({
        path: "/shopifyStores"
      });
    },
    // 物流列表
    enterLogistics() {
      this.$router.push({
        path: "/logistics"
      });
    },
    // 物流查询
    enterLogisticsQuery() {
      this.$router.push({
        path: "/logisticsQuery"
      });
    },
    // SKU列表
    enterSKU() {
      this.$router.push({
        path: "/sku"
      });
    },
    //登录
    enterLogin() {
      this.$router.push({
        path: "/login"
      });
    },
    // 收款设置
    enterPaymentSet() {
      this.$router.push({
        path: "/paymentSet"
      });
    },
    // 物流设置
    enterLogisticsSet() {
      this.$router.push({
        path: "/logisticsSet"
      });
    },
    //角色管理
    enterRoleManager() {
      this.$router.push({
        path: "/roleManager"
      });
    },
    //广告账号管理
    enterAdvNumber() {
      this.$router.push({
        path: "/advNumber"
      });
    },
    // 评论
    enterComment() {
      this.$router.push({
        path: "/comment"
      });
    },
    // 折扣
    enterDiscount() {
      this.$router.push({
        path: "/discount"
      });
    },
    // 员工管理
    enterAddUser() {
      this.$router.push({
        path: "/addUser"
      });
    },
    // FB开户
    enterFBaccount() {
      this.$router.push({
        path: "/FBaccount"
      });
    },
    // 投放日报
    enterDialy() {
      this.$router.push({
        path: "/dialy"
      });
    },
    // 退出登陆
    exitLogin() {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("appToken");

      this.$cookies.remove("token");
      this.$cookies.remove("appToken");

      this.$router.push({
        path: "/login"
      });
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    }
  },
  mounted() {
    GetUserHeaderInfo().then(res => {
      if (res) {
        this.userInfo = res;
      }
    });

  },
  components: {
    copyRight
  }
};
</script>

<style lang="less">
[v-cloak] {
  display: none;
}
#app {
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.logo {
  width: 36px;
  height: 36px;
  background-color: #0077ff;
  border-radius: 50%;
}
.el-header,
.el-footer {
  background: rgba(255, 255, 255, 1);
  border-right: 1px solid rgba(235, 237, 248, 1);
  color: #333;
  text-align: center;
  line-height: 70px;
}
.el-menu {
  border-right: none !important;
}
.el-aside {
  background: #262835;
  color: #333;
  height: 100%;
  box-sizing: border-box;
  > .left {
    height: 60px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding-left: 20px;
  }
}
.el-main {
  background: rgba(250, 251, 252, 1);
  border-top: 1px solid rgba(235, 237, 248, 1);
  color: #333;
  padding-top: 10px !important;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
.el-container.is-vertical {
  height: 100%;
}
.headers {
  display: flex;
  justify-content: space-between;
  padding-left: 0px !important;
  padding-right: 34px !important;
  .left {
    display: flex;
    align-items: center;
    padding-left: 20px;
    box-sizing: border-box;
  }
  .right {
    display: flex;
    align-items: center;
    .headImg {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      overflow: hidden;
      > img {
        width: 40px;
        height: 40px;
      }
    }
    .name {
      height: 15px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(34, 34, 34, 1);
      line-height: 15px;
      padding-left: 10px;
      &:hover {
        cursor: pointer;
      }
    }
    span:nth-child(3) {
      color: rgba(190, 190, 190, 1);
      margin: 0 10px;
    }
    .isLogin {
      width: 60px;
      height: 14px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 14px;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
.list {
  .item {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(127, 143, 164, 1);
    line-height: 48px;
    padding: 0 20px;
    > span:first-child {
      margin-right: 20px;
    }
    &:hover {
      cursor: pointer;
    }
  }
}
.iconfont {
  margin-right: 16px;
}

.container {
  height: 100%;
}
.asides {
  position: relative;
  height: 100%;
}
.main {
  overflow: hidden !important;
}
</style>
